module.exports = __webpack_public_path__ + "static/media/icon-mobile-agreed.6cfa7464.svg";